/**
 * Created by 212610877 on 5/30/2017.
 */


// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
// Polyfill forEach for  NodeList
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, argument) {
    argument = argument || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(argument, this[i], i, this);
    }
  };
}

// HTMLMediaElement.prototype.pause = function () {
//   // debugger;
//   console.log(' *******  Video is Paused  *************');
// }



// WEBPACK FOOTER //
// ./src/assets/js/polyfill.js